// extracted by mini-css-extract-plugin
module.exports = {"company-customer-login-page":"CompanyCustomerLoginPage_company-customer-login-page__24fkb"};